<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto;">
      <div class="row">
        <div class="col-5">
          <h1>Widget Management</h1>
        </div>
        <div class="col-4">
          <br />
          <ng-container *ngIf="loadingData">
            <i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;Loading Widget Data, Please Wait...
          </ng-container>
        </div>
        <div class="col-3"></div>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="!loadingData">
    <mat-card-content>
      <mat-card style="margin-top: 10px">
        <mat-card-content style="margin-left: auto; margin-right: auto;">
          <div class="row">
            <div class="col-md-2"><b>Select Widget Type: </b></div>
            <div class="col-md-7">
              <mat-select name="selectedEmbeddedReport" [(ngModel)]="selectedEmbeddedReport" (selectionChange)="embeddedReportChanged()">
                <mat-option *ngFor="let report of reportEmbeddedTypes" [value]="report">{{ report.name }}</mat-option>
              </mat-select>
            </div>
            <div class="col-md-3">
              <button *ngIf="selectedEmbeddedReport != null" mat-raised-button class="piButton" (click)="createNewEmbeddedReport()">Create New Widget</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card style="margin-top: 10px">
        <mat-card-content style="margin-left: auto; margin-right: auto">
          <div class="row">
            <div class="col-md-2 mainLabel"></div>
            <div class="col-md-2 mainLabel">Widget</div>
            <div class="col-md-3 mainLabel">Type</div>
            <div class="col-md-4 mainLabel">Subscription</div>
            <div class="col-md-1 mainLabel">Disabled</div>
          </div>
          <ng-container *ngFor="let embed of filteredReportEmbeds">
            <div class="row table-row">
              <div class="col-md-2">
                <ng-container *ngIf="embed.canEdit"><a href="#" (click)="editEmbed(embed, false)"><span class="fas fa-edit" title="Edit Widget"></span></a>&nbsp;&nbsp;</ng-container>
                <ng-container *ngIf="embed.canEdit"><a href="#" (click)="editEmbed(embed, true)"><span class="far fa-edit" title="Edit Widget Clearing State"></span></a>&nbsp;&nbsp;</ng-container>
                <ng-container *ngIf="embed.canEdit"><a href="#" (click)="deleteEmbed(embed)"><span class="fas fa-trash" title="Delete Widget"></span></a>&nbsp;&nbsp;</ng-container>
                <ng-container *ngIf="!embed.gatedOnly"><a href="#" (click)="copyEmbedUrl(embed)"><span class="fas fa-object-ungroup" title="Copy Un-Gated Widget URL"></span></a>&nbsp;&nbsp;</ng-container>
                <ng-container><a href="#" (click)="copyPublicEmbedUrl(embed)"><span class="fas fa-object-group" title="Copy Gated Widget URL"></span></a>&nbsp;&nbsp;</ng-container>
                <ng-container><a href="#" (click)="launchEmbed(embed)"><span class="fas fa-rocket" title="Launch Widget"></span></a></ng-container>
              </div>
              <div class="col-md-2"><b>{{ embed.name }}</b></div>
              <div class="col-md-3">{{ embed.reportName }}</div>
              <div class="col-md-4">{{ embed.subscription }}</div>
              <div class="col-md-1">{{ embed.disabled }}</div>
            </div>
            <div class="row table-row">
              <div class="col-md-6">

              </div>
            </div>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
<div [hidden]="!showPowerBi" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1000; background-color: #106bae">
  <app-powerbi-report-embed (closeClicked)="closeClicked()" (saveClicked)="saveClicked()"></app-powerbi-report-embed>
</div>
